import React, { useState } from "react";
import { Language, translations, TranslationKey } from "@/locales/translations";

export const LanguageProvider = ({
  children,
  storageKey = "ui-language",
}: {
  children: React.ReactNode;
  storageKey: string;
}) => {
  const [language, setLanguage] = useState<Language>(
    () => (localStorage.getItem(storageKey) as Language) || "en",
  );

  const value = {
    language,
    setLanguage: (lang: Language) => {
      localStorage.setItem(storageKey, lang);
      setLanguage(lang);
    },
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

interface LanguageContextType {
  language: Language;
  setLanguage: (language: Language) => void;
}

export const LanguageContext = React.createContext<
  LanguageContextType | undefined
>(undefined);

export const useTranslation = () => {
  const context = React.useContext(LanguageContext);
  if (!context) {
    throw new Error("useTranslation must be used within a LanguageProvider");
  }
  const { language } = context;
  const t = (key: TranslationKey, variables?: Record<string, string>) => {
    const translation = translations[language]?.[key] || key;

    if (!variables) {
      return translation;
    }
    // 변수 치환 로직
    // /{    // 리터럴 문자 '{' 찾기
    //   (    // 캡처 그룹 시작
    //     \w  // word character (알파벳, 숫자, _)
    //     +   // 앞의 패턴이 1회 이상 반복
    //   )    // 캡처 그룹 끝
    // }/    // 리터럴 문자 '}' 찾기
    // g     // global flag (전체 문자열에서 모든 매칭을 찾음)
    // match: 전체 매칭된 문자열 (예: "{name}")
    // variable: 첫 번째 캡처 그룹의 값 (예: "name")
    return translation.replace(/{(\w+)}/g, (match, variable) => {
      return variables[variable] || match;
    });
  };
  return { t, language, setLanguage: context.setLanguage };
};
